import { useEffect, useRef, useState } from 'react'
import { X } from 'react-feather'

import {
  Wrapper,
  Backdrop,
  StyledModal,
  CloseButton,
} from './modalStyle'

export const useModal = (id = 'modal') => {
  const openModalButtonRef = useRef()
  const [isOpen, setIsOpen] = useState(false)
  const [hasBeenOpened, setHasBeenOpened] = useState(false)

  useEffect(() => {
    if (!isOpen && hasBeenOpened) {
      openModalButtonRef.current?.focus()
    }
  }, [isOpen, hasBeenOpened])

  return {
    modalButtonProps: {
      'aria-controls': id,
      ref: openModalButtonRef,
      onClick: () => {
        setIsOpen(true)
        setHasBeenOpened(true)
      },
    },
    modalProps: {
      id,
      isOpen: isOpen,
      onClose: () => setIsOpen(false),
    },
    isOpen,
    setIsOpen,
  }
}

const Modal = ({
  isOpen,
  onClose,

  children,
  focusRef,
  ...props
}) => {
  const modalRef = useRef()
  const buttonRef = useRef()

  useEffect(() => {
    if (isOpen) focusRef ? focusRef.current?.focus() : buttonRef.current?.focus()
  }, [isOpen, focusRef])

  useEffect(() => {
    const onFocus = () => {
      if (modalRef.current?.contains(document.activeElement)) return
      buttonRef.current?.focus()
    }
    if (isOpen) {
      window.addEventListener('focus', onFocus)
    }
    return () => window.removeEventListener('focus', onFocus)
  }, [isOpen])
  
  return isOpen && (
    <Wrapper>
      <Backdrop onClick={onClose} />

      <StyledModal
        role="dialog"
        ref={modalRef}
        onBlur={e => {
          if (modalRef.current?.contains(e.relatedTarget)) return
          buttonRef.current?.focus()
        }}
        onKeyUp={e => {
          if (e.key === 'Escape') onClose()
        }}
        {...props}
      >
        <CloseButton
          ref={buttonRef}
          type="button"
          onClick={onClose}
          title="Close modal"
        ><X /></CloseButton>

        {children}
      </StyledModal>
    </Wrapper>
  )
}

export default Modal